import { ChatChannelIds } from '@core/types';
import { Button, Close, CloseAndMarkUnread } from '@core/ui';
import { useAppDispatch, useAppSelector } from '@online-webinar/store/src/hooks';
import { leaveChatChannel, markChatChannelAsUnread } from '@online-webinar/store/src/slices/live-webinar-slice';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export const ChatChannelTabName = ({ channelId }: { channelId: string }) => {
    const { t } = useTranslation();
    const channel = useAppSelector((state) => state.liveWebinar.joinedChannelsInfo[channelId]);
    const [channelName, setChannelName] = useState<string>();
    const dispatch = useAppDispatch();

    useEffect(() => {
        setChannelName(getChannelName());
    }, [channelId, channel]);

    const getChannelName = () => {
        if (channelId === ChatChannelIds.allChannel) {
            return t('Chat.ChannelName.All');
        }
        if (channelId === ChatChannelIds.publicChannel) {
            return t('Chat.ChannelName.Public');
        }
        if (channelId === ChatChannelIds.moderatorChannel) {
            return t('Chat.ChannelName.Moderator');
        }
        if (channelId === ChatChannelIds.presenterChannel) {
            return t('Chat.ChannelName.Presenter');
        }
        if (channelId === ChatChannelIds.speakersChannel) {
            return t('Chat.ChannelName.Speakers');
        }

        return channel.channelName || t('Chat.ChannelName.Unknown');
    };

    const leaveAndMarkAsUnread = () => {
        dispatch(leaveChatChannel(channelId));
        setTimeout(() => {
            dispatch(markChatChannelAsUnread(channelId));
        }, 50);
    };

    const leaveChannel = () => {
        dispatch(leaveChatChannel(channelId));
    };

    return (
        <>
            {channelName}
            {channel.noOfUnreadMessages > 0 && (
                <span className="text-xs font-semibold bg-warning text-white px-2 rounded-full ms-1 -me-2 mb-3">{channel.noOfUnreadMessages}</span>
            )}
            {!ChatChannelIds.isSystemChannel(channelId) && (
                <>
                    <Button type="button" onClick={leaveAndMarkAsUnread} iconbtn classNames="ms-2">
                        <CloseAndMarkUnread classNames="size-6 -m-0.5 stroke-current" />
                        <span className="sr-only">{t('Chat.Channel.Button.CloseAndMarkUnread', { channelName })}</span>
                    </Button>
                    <Button type="button" onClick={leaveChannel} iconbtn>
                        <Close classNames="size-6 -m-0.5 stroke-current" />
                        <span className="sr-only">{t('Chat.Channel.Button.Close', { channelName })}</span>
                    </Button>
                </>
            )}
        </>
    );
};
